import { computed } from "vue";

import type { GraphDatabase, OrgId, WorkspaceId } from "@ctrl/controller-rpc";

import * as inject from "@/components/inject";

export type WorkspaceEntry = {
  id: WorkspaceId;
  name: string;
  orgId: OrgId;
  databases: Record<string, GraphDatabase>;
};

/**
 * Returns a computed ref of workspace entries, each with its metadata and
 * databases, derived from inject.profile() and inject.workspaceDatabases().
 * Only workspaces present in workspaceDatabases are included.
 */
export const useWorkspaceDatabaseGroups = () => {
  const profile = inject.profile();
  const workspaceDatabases = inject.workspaceDatabases();

  return computed<WorkspaceEntry[]>(() => {
    const allDatabases = workspaceDatabases.value;
    if (!allDatabases) return [];

    const result: WorkspaceEntry[] = [];

    for (const org of profile.value.organizations) {
      for (const ws of org.workspaces) {
        const databases = allDatabases[ws.id];
        if (!databases) continue;
        result.push({
          id: ws.id,
          name: ws.name,
          orgId: org.id,
          databases,
        });
      }
    }

    return result;
  });
};
